import { initAdvertoryPackage } from '@sch-inventory/advertory/core/e24/es';
import { prepareAdvertoryConfig } from './config';

export default async (): Promise<void> =>
    initAdvertoryPackage(await prepareAdvertoryConfig());
